export const remarks = [
    {
        key: 'HELPFUL',
        translation: 'pages.on_demand_feedback.fixed_remark.helpful',
    },
    {
        key: 'INTERESTING',
        translation: 'pages.on_demand_feedback.fixed_remark.interesting',
    },
    {
        key: 'RELEVANT',
        translation: 'pages.on_demand_feedback.fixed_remark.relevant',
    },
    {
        key: 'INFORMATIVE',
        translation: 'pages.on_demand_feedback.fixed_remark.informative',
    },
    {
        key: 'PRACTICAL',
        translation: 'pages.on_demand_feedback.fixed_remark.practical',
    },
    {
        key: 'INSIGHTFUL',
        translation: 'pages.on_demand_feedback.fixed_remark.insightful',
    },
] as const;
